import { configureStore } from "@reduxjs/toolkit"
import  authSlice from "../pages/auth/authSlice"
import adminUserSlice from "../pages/manageAdminUser/adminUserSlice"
import merchantSlice from "../pages/ManageMerchants/merchantSlice"
import supportTicketsSlice from "../pages/SupportTickets/supportTicketsSlice"
import OrdersSlice from "../pages/OrdersAndPurchase/components/OrdersSlice"
import privilagesSlice from "../pages/auth/privilagesSlice"
import CutomizationSlice from "../pages/ManageMerchants/components/Customization/CutomizationSlice"

import {persistReducer, persistStore} from "redux-persist"
import storage from 'localforage';
import SettlementsSlice from "../pages/CryptoSettlements/Components/SettlementsSlice"

const persistConfig = {
    key: 'root', // key for the storage
    storage, // storage engine to use
};

// const persistedReducer = persistReducer(persistConfig, privilagesSlice);

export const store = configureStore({
    reducer: {
        auth:authSlice,  
        adminUserState : adminUserSlice,
        merchantState:merchantSlice,
        SupportList: supportTicketsSlice,
        Orders: OrdersSlice,
        Settlements: SettlementsSlice,
        Privilages: privilagesSlice,
        customization:CutomizationSlice,
    },
})

// export const persistor = persistStore(store);